<template>
  <div class="cycles-table fbc-table-header-labels" data-testid="cycles-page__table">
    <div class="lb-datatableaction-wrapper cycles-table__datatable-wrap">
      <lb-datatableaction
        ref="dataTable"
        :headers="headers"
        :tabledata="cycles"
        :displayedRowCount="paginatedCycles.length"
        :itemsperpage="itemsPerPage"
        :bulkActions="false"
        :showToolbar="false"
        :showClearFilter="false"
        :loading="loading"
        :selectfilter="{}"
        :page_details="{}"
        data-testid="bookclosure-project-list__datatable"
        header-bg-class="fbc-table-header-bg"
      >
        <template #tbody="{ headers: slotHeaders }">
          <CycleTableRow
            v-for="(cycle, index) in paginatedCycles"
            :key="cycle._id"
            :cycle="cycle"
            :headers="slotHeaders || headers"
            :userid="userid"
            :locations-map="locationsMap"
            :actor-role-label="actorRoleLabel"
            :actor-location-ids="actorLocationIds"
            :right="right"
            :upsi-enabled="upsiEnabled"
            :index="index"
            @click="$emit('row-click', $event)"
            @close-cycle="$emit('close-cycle', $event)"
            @reopen-cycle="$emit('reopen-cycle', $event)"
            @edit-cycle="$emit('edit-cycle', $event)"
            @toggle-notification="$emit('toggle-notification', $event)"
            @retry-cycle-creation="$emit('retry-cycle-creation', $event)"
            @delete-cycle="$emit('delete-cycle', $event)"
            @upsi-publish="(cycleRow, mode) => $emit('upsi-publish', cycleRow, mode)"
            @upsi-review="$emit('upsi-review', $event)"
            @upsi-view-details="$emit('upsi-view-details', $event)"
          />
        </template>
      </lb-datatableaction>
    </div>
  </div>
</template>

<script>
import './CyclesTable.scss';
import CycleTableRow from '../CycleTableRow/CycleTableRow.vue';
import { TABLE_HEADERS, ITEMS_PER_PAGE } from '../../utils/cyclesConstants';

export default {
  name: 'CyclesTable',

  components: {
    CycleTableRow,
  },

  props: {
    cycles: {
      type: Array,
      default: () => [],
    },
    paginatedCycles: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    itemsPerPage: {
      type: Number,
      default: ITEMS_PER_PAGE,
    },
    userid: {
      type: String,
      default: '',
    },
    locationsMap: {
      type: Object,
      default: () => ({}),
    },
    actorRoleLabel: {
      type: String,
      default: '',
    },
    actorLocationIds: {
      type: Array,
      default: () => [],
    },
    right: {
      type: String,
      default: 'financialclose_project',
    },
    upsiEnabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
